import { render, staticRenderFns } from "./HazirEvrakGonderIslemDetayView.vue?vue&type=template&id=de12962e&scoped=true"
import script from "./HazirEvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./HazirEvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de12962e",
  null
  
)

export default component.exports